<template>
  <v-ons-page id="podcast"
    v-bind:class="{ 'page__content-ph-animate': initLoading }"
  >
    <app-bar :title="channel && channel.title || title" :enable-home="true" :enable-ticker="true" />
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-show="loading"></v-ons-progress-bar>
    <div class="channel-header ">
      <section>
        <div class="avatar-line justify-row container">
          <div class="avatar avatar-podcast">
            <div class="avatar-border"></div>
            <img class="round-sm" :src="constants.phImg70x70" v-if="initLoading || !channel">
            <img-with-placeholder class="round-sm" :src="constants.phImg70x70" :data-src="sizeImg(channel.image_base_url, 70, 70)" :alt="channel.image.alt_text" v-else />
          </div>
          <div class="main-item">
            <h2 class="name ph-text"
              v-if="initLoading"
            >■■■■■■■■ ■■■■■■■■</h2>
            <h2 class="name"
              v-else-if="channel"
            >{{ channel.title }}</h2>
            <h2 class="name ph-text"
              v-else-if="isOffline"
            >■■■■■■■■ ■■■■■■■■</h2>
            <div class="tools">
              <ons-button class="subscribe js-button-toggle btn-outline" modifier="small"
                v-bind:class="{ switched: channel && channel.is_subscribed, 'ph-icon': initLoading }"
                :disabled="initLoading || subscribeLoading"
                @click="toggleSubscribe()"
              >
                <span class="icon-sm">
                  <icon-unsubscribe />
                </span>
                <span class="ph-text" v-if="initLoading">■■■■■■■■■■</span>
                <span class="txt" v-else>{{ (channel && channel.is_subscribed) ? $t("channel.unsubscribe") : $t("channel.subscribe") }}</span>
              </ons-button>
              <ons-button class="enable-auto-download js-button-toggle btn-outline" modifier="small"
                v-bind:class="{ switched: channel && channel.auto_download_enabled, 'ph-icon': initLoading }"
                :disabled="initLoading || subscribeLoading || autoDownloadLoading"
                @click="toggleAutoDownload()"
              >
                <span class="ph-text" v-if="initLoading">■■■■ ■■■■■■■ ■■■■■</span>
                <span class="txt" v-else>{{ (channel && channel.auto_download_enabled) ? $t("channel.disable_auto_download") : $t("channel.enable_auto_download") }}</span>
              </ons-button>
              <ons-button class="donate js-donate btn-outline" modifier="small"
                v-if="false"
                @click="openDonateActionSheet()"
              >
                <span class="icon-sm">
                  <icon-donate />
                </span>
                <span class="ph-text" v-if="initLoading">■■■■■■■</span>
                <span class="txt" v-else>Donate</span>
              </ons-button>
              <ons-button class="share btn-outline button button--small" modifier="small"
                          @click="share()"
              >
                <span class="txt">
                  {{ $t("channel.share") }}
                </span>
              </ons-button>
              <ons-button class="embed js-embed btn-outline button button--small" modifier="small"
                          @click="copyEmbedCode()"
              >
                <span class="txt">
                  {{ $t("channel.embed") }}
                </span>
              </ons-button>
              <ons-button class="report js-report button button--small button--quiet" modifier="small quiet"
                :disabled="initLoading"
                @click="report()"
              >
                <span class="icon-sm">
                  <icon-report />
                </span>
                <span class="ph-text" v-if="initLoading">■■■■■■ ■■■■ ■■■■■■■</span>
                <span class="txt" v-else>{{ $t("channel.report") }}</span>
              </ons-button>
              <ons-button class="" modifier="small quiet"
              v-if="channel.private"
              >
                <span class="icon-sm">
                  <img src="@/assets/img/private.svg" alt="Private" width="30" height="30">
                </span>
              </ons-button>
            </div>
          </div>
        </div>
        <div class="container">
          <p class="p ph-text" v-if="initLoading">■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■ ■■■■■■■■■■</p>
          <p class="p" v-else-if="channel">{{ channel.short_description | truncate(400) }}</p>
          <p class="p" v-if="isOffline">{{ $t("channel.offline") }}</p>
        </div>
      </section>
    </div>
    <div class="tabs tabbar tabbar--top" data-control="#tabs-content-podcast">
      <label class="tabbar__item" data-index="1">
      <input type="radio" name="tab-podcast" checked="checked" @click="setTabIndex(0)">
      <button class="tabbar__button"
        v-bind:class="{ 'ph-btn': initLoading }"
      >
        {{ $t("channel.nav.episodes") }}
      </button>
      </label>
      <label class="tabbar__item" data-index="2">
      <input type="radio" name="tab-podcast" @click="setTabIndex(1)">
      <button class="tabbar__button">
        {{ $t("channel.nav.more_channels") }}
      </button>
      </label>
      <label class="tabbar__item" data-index="3">
      <input type="radio" name="tab-podcast" @click="setTabIndex(2)">
      <button class="tabbar__button">
        {{ $t("channel.nav.about_channel") }}
      </button>
      </label>
    </div>
    <div class="tabs-content" id="tabs-content-podcast">
      <div v-show="tabIndex === 0">
        <div class="pd-bottom container">
          <episode-list-detailed :episodes="channel && channel.episodes" :channel="channel" :loading="initLoading" :loading-item-count="10" />
        </div>
        <div class="center-align" v-if="!initLoading && !isOffline">
          <p>
            <v-ons-button class="btn-outline" modifier="long"
              v-show="channel && !channel._episodesEnded"
              :disabled="loading"
              @click="loadMore()"
            >{{ $t("ui.load_more") }}</v-ons-button>
          </p>
          <p v-show="channel && channel._episodesEnded">{{ $t("ui.no_more") }}</p>
        </div>
      </div>
      <div v-show="tabIndex === 1">
        <section class="bg-gradient pd-both container" v-show="hostOtherChannels.length > 0">
          <h2 class="row-title1">{{ $t("channel.more_channels.by_the_host") }}</h2>
          <channel-grid :channels="hostOtherChannels" />
        </section>
        <div class="bg-gradient pd-both container">
          <h2 class="row-title1">{{ $t("channel.more_channels.recommended_channels") }}</h2>
          <div class="pd-bottom">
            <channel-grid :channels="channel && channel.recommended_channels" />
          </div>
        </div>
      </div>
      <div v-show="tabIndex === 2">
        <section class="bg-gradient pd-both container">
          <h2 class="row-title1">{{ $t("channel.about_channel.title") }}</h2>
          <div class="html" v-if="!initLoading && channel && channel.full_description">
            <div v-html="$sanitizeHTML(channel.full_description)"></div>
          </div>
        </section>
        <section class="pd-both container">
          <h2 class="row-title1">{{ $t("channel.about_channel.host") }}</h2>
          <div class="avatar-line justify-row js-newpage" data-page="host.html" data-title="Cassie">
            <div class="avatar js-newpage"><a href=""
              @click.prevent="navigatorPush('Host', { id: channel.host.id, title: channel.host.user.name })"
            ><img-with-placeholder class="round-max" :src="constants.phImg70x70" :data-src="sizeImg(channel.host.user.avatar.base_url, 70, 70)" :alt="channel.host.user.avatar.alt_text" v-if="channel && channel.host && channel.host.user" /></a></div>
            <div class="host main-item">
              <h3 class="name js-newpage"
                @click.prevent="navigatorPush('Host', { id: channel.host.id, title: channel.host.user.name })"
                ><a href="">{{ channel && channel.host && channel.host.user && channel.host.user.name }}</a></h3>
              <div class="tools">
                <ons-button modifier="small" class="donate js-donate btn-outline"
                  v-if="false"
                  @click="openDonateActionSheet()"
                >
                  <span class="icon-sm">
                    <icon-donate />
                  </span>
                  <span class="txt">Donate</span>
                </ons-button>
                <span>&nbsp;</span>
                <ons-button modifier="small" class="follow js-button-toggle btn-outline"
                  v-bind:class="{ switched: channel && channel.host && channel.host.is_following }"
                  :disabled="followLoading"
                  @click="toggleFollow()"
                >
                  <span class="icon-sm">
                    <icon-follow />
                  </span>
                  <span class="txt">{{ (channel && channel.host && channel.host.is_following) ? $t("host.unfollow") : $t("host.follow") }}</span>
                </ons-button>
              </div>
            </div>
          </div>
          <p class="p"
            v-for="descP in (!initLoading && channel && channel.host && channel.host.description ? channel.host.description.split('\n') : [])"
          >{{ descP }}</p>
        </section>
      </div>
    </div>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_for_details") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
    <float-player class="player-iphonex-apply-bottom-notch" />
  </v-ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';
import EpisodeListDetailed from '@/components/EpisodeListDetailed.vue';
import ChannelGrid from '@/components/ChannelGrid.vue';
import FloatPlayer from '@/components/FloatPlayer.vue';
import TabHelper from '@/mixins/TabHelper';
import Channel from '@/models/Channel';
import WatchUserChangeHelper from '@/mixins/WatchUserChangeHelper';

export default {
  name: 'channel',
  props: ['id', 'title'],
  components: {
    'app-bar': AppBar,
    'episode-list-detailed': EpisodeListDetailed,
    'channel-grid': ChannelGrid,
    'float-player': FloatPlayer,
  },
  mixins: [TabHelper, WatchUserChangeHelper],

  data() {
    return {
      initLoading: true,
      loading: true,
      subscribeLoading: false,
      autoDownloadLoading: false,
      followLoading: false,
    };
  },

  computed: {
    channel() {
      return Channel.query().whereId(this.id).with('host.user|channels').with('episodes').with('recommended_channels').first();
    },
    hostOtherChannels() {
      if (this.channel && this.channel.host && this.channel.host.channels && (this.channel.host.channels.length > 0)) {
        return this.channel.host.channels.filter(channel => channel.id != this.id);;
      }
      return  [];
    },
  },

  methods: {
    toggleSubscribe() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_sub"))) { return; }
      let that = this;
      this.loading = true;
      this.subscribeLoading = true;
      this.channel.toggleSubscribe(this.currentUser.id)
        .then(() => {
          this.currentUser.updateSubscriptionsChanged(true);
        }).catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.subscribeLoading = false;
          if (this.channel.is_subscribed) { this.askPushNotification(); }
        });
    },
    toggleAutoDownload() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_change_auto_download_setting"))) { return; }
      let that = this;
      this.loading = true;
      this.autoDownloadLoading = true;
      this.channel.toggleAutoDownload(this.currentUser.id)
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.autoDownloadLoading = false;
        });
    },
    toggleFollow() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_follow"))) { return; }
      let that = this;
      this.loading = true;
      this.followLoading = true;
      this.channel.host.toggleFollow(this.currentUser.id)
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.followLoading = false;
        });
    },
    share() {
      let path = this.$router.resolve({
        name: 'channel',
        params: { id: this.channel.id, slug: this.slugify(this.channel.title,{strict:true}) },
      });
      let urlPrefix = window.location.href;
      urlPrefix = urlPrefix.split('/');
      urlPrefix = urlPrefix[0] + '//' + urlPrefix[2];
      let pathHref = path.href;
      if (this.$isCordova) {
        urlPrefix = 'https://player.edifi.app';
        pathHref = path.href.substr(1);
      }
      let url = urlPrefix + pathHref;
      if (this.$isCordova) {
        window.plugins.socialsharing.shareWithOptions({
          subject: this.$t("channel.subject_for_sharing", { channel_title: this.channel.title }),
          url: url,
        });
      } else {
        if (window.navigator.share) {
          window.navigator.share({
            title: this.$t("channel.subject_for_sharing", { channel_title: this.channel.title }),
            url: url,
          });
        } else {
          this.copyToClipboard(url);
          this.$ons.notification.toast(this.$t("channel.link_copied"), { timeout: 3000, animation: 'fall' });
        }
      }
    },
    copyLink() {
      let urlPrefix = "https://player.edifi.app/channels/";
      let pathHref = this.slugify(this.channel.title,{strict:true}) + '/' + this.channel.id;
      let url = urlPrefix + pathHref;
      this.copyToClipboard(url);
      this.$ons.notification.toast(this.$t("channel.link_copied"), { timeout: 3000, animation: 'fall' });
    },
    copyEmbedCode() {
      let urlPrefix = "https://player.edifi.app/embed/index.html#/channels/";
      let pathHref = this.slugify(this.channel.title,{strict:true}) + '/' + this.channel.id;
      let url = urlPrefix + pathHref;
      let embedCode = `<iframe style="width: 1px; min-width: 100%;" height="510" src="${encodeURI(url)}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><script src="https:\/\/player.edifi.app/embed/host.js"><\/script>`;
      this.copyToClipboard(embedCode);
      this.$ons.notification.toast(this.$t("channel.embed_copied"), { id:'share-copied', timeout: 3000, animation: 'fall' });
    },
    report() {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_report"))) { return; }
      let that = this;
      this.openReportActionSheet().then((reason) => {
        if (!reason) { return; }
        that.channel.createReport(this.currentUser.id, reason).then(() => {
          that.$ons.notification.toast(this.$t("messages.report_received"), { timeout: 3000, animation: 'fall' });
        }).catch((error) => {
          console.log(error);
          that.showSomethingWrongToast();
        });
      });
    },
    loadMore() {
      let that = this;
      this.loading = true;
      this.channel.fetchMoreEpisodes()
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
    onUserChanged() {
      let that = this;
      this.loading = true;
      Channel.fetchById(this.id)
        .catch(function (error) {
          console.log(error);
          if (that.isOffline) { return; }
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    let that = this;
    this.initLoading = true;
    this.loading = true;
    Channel.fetchById(this.id)
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          that.navigatorResetLogin(that.$t("messages.login_required"));
        } else {
          console.log(error);
          if (that.isOffline) { return; }
          that.showSomethingWrongToast();
        }
      }).finally(() => {
        this.initLoading = false;
        this.loading = false;
      });
  },
};
</script>
